module.exports = __webpack_public_path__ + "static/adegoke-49dd86b6df5ee537dce0aa2a11788cdc.jpg";